import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Nav } from "react-bootstrap";
import { useLocation, useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUrlDetailsObj, getUserStatsObject, recordActivity } from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
import { useDispatch } from "react-redux";
import { fetchRevenueAnalysisRequest } from "../../../store/features/actions/fetchRevenueAnalysisAction";
import { fetchReGeoWisevenueAnalysisRequest } from "../../../store/features/actions/fetchGeoWiseRevenueAnalysisAction";
import { fetchCompFinancialRequest } from "../../../store/features/actions/companyFinancialsActions";
import { fetchSegmentsRequest } from "../../../store/features/actions/segmentsActions";
import { fetchKeyConversationRequest } from "../../../store/features/actions/keyConversationActions";
import CompanyOverview from "./CompanyOverview";
import NudgesAndEvents from "./NudgesAndEvents/NudgesAndEvents";
import NudgesNew from "./NudgesAndEvents/NudgesNew";
// import QuestionsPromtersTab from "./Questions/QuestionsPromtersTab";

import CompanyLogoSkeleton from "../skeletons/companyLogoSkeleton";
import { fetchAccountContactRequest } from "../../../store/features/actions/accountContactsActions";
import { fetchDynamicTabsRequest } from "../../../store/features/actions/dynamicTabActions";
import "./AccountDetailsTabsV2.css"
import MoreComps from "./MoreCompoents/MoreComps";
import TargetedReachOutComp from "./TargetedReachOut/TargetedReachOutComp";
import MaximisePipeComp from "./Opportunities/MaximisePipeComp";
import * as FeatherIcon from "react-feather";
import MeetingPrepComp from "./MeetingPrep/MeetingPrepComp";
import NudgesNewM from "./NudgesAndEvents/NudgesNew/NudgesNewM";

function AccountDetailsTabsV2() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useUser();
  // console.log("user",user)
  const { clientName, accountId, accountName } = useParams();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTabFromUrl = searchParams.get("tab") || "accountPlan";

  const { account_info, account_info_loading } = useSelector(state => state.accountsReducer);
  const { account_contacts, account_contacts_loading } = useSelector(state => state.accountContactsReducer);
  const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);
  const [accountContactList, setAccountContactList] = useState([]);

  useEffect(() => {
    dispatch(fetchDynamicTabsRequest({ clientName, accountName }));
  }, []);

  // useEffect(() => {
  //   const debounceTimer = setTimeout(() => {
  //     setSearchParams({ tab: activeParentTabKey });
  //   }, 100);
  //   return () => clearTimeout(debounceTimer);
  // }, [activeParentTabKey]);

  useEffect(() => {
    if (activeTabFromUrl !== activeParentTabKey) {
      setParentActiveTab(activeTabFromUrl);
    }
  }, [activeTabFromUrl]);

  useEffect(() => {
    if (account_info?.ticker) {
      dispatch(fetchRevenueAnalysisRequest({ ticker: account_info?.ticker }));
      dispatch(fetchReGeoWisevenueAnalysisRequest({ ticker: account_info?.ticker }));
    }
  }, [account_info?.ticker]);

  useEffect(() => {
    if (accountName) {
      dispatch(fetchSegmentsRequest({ accountName }));
      dispatch(fetchKeyConversationRequest({ accountName }));
      dispatch(fetchCompFinancialRequest({ accountName }));
    }
    if (accountName && (activeParentTabKey === "business" || activeParentTabKey === "contacts")) {
      dispatch(fetchAccountContactRequest(accountName));
    }
  }, [accountName, activeParentTabKey]);

  useEffect(() => {
    const tabTypeMap = {
      accountPlan: "Account Plan",
      maximise_pipe: "Maximise Pipe",
      business: "Business",
      growth: "Growth Opportunities",
      nudges_new: "NudgesNew",
      documents: "Documents",
      competitor_insights: "Competitor Analysis",
      technology: "Tech Landscape",
      financial: "Financials",
      agents: "Agents",
      targeted_reach_out:"Targeted Reach Out",
      meeting_prep:"Meeting Prep",
      more: "More"
    };

    const tabType = tabTypeMap[activeParentTabKey];
    if (tabType) {
      pageParsedData.query_params = { tab: activeParentTabKey };
      const userStat = getUserStatsObject(
        tabType,
        "page_load",
        `Page Source: ${accountName}`,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [activeParentTabKey]);

  useEffect(() => {
    if (user?.company_id && !account_contacts_loading) {
      setAccountContactList(account_contacts || { records: [], filters: {} });
    }
  }, [user?.company_id, account_contacts, account_contacts_loading]);

  const handleTabChange = useCallback((key) => {
    if (
      [
        "accountPlan",
        "business",
        "growth",
        "nudges_new",
        "agents",
        "competitor_insights",
        "technology",
        "financial",
        "documents",
        "maximise_pipe",
        "targeted_reach_out",
        "meeting_prep",
        "more",
      ].includes(key)
    ) {
      setParentActiveTab(key);
    }
  }, []);

  const renderContent = () => {
    switch (activeParentTabKey) {
      case "accountPlan":
        return <CompanyOverview />;
      case "maximise_pipe":
        return <MaximisePipeComp />;  
      case "nudges_new":
        return <NudgesNewM />;
      case "targeted_reach_out":
        return <TargetedReachOutComp/>
      case "meeting_prep":
          return <MeetingPrepComp/>
      case "more":
        return <MoreComps accountContactList={accountContactList}/>;  
      default:
        return null;
    }
  };

  const tabItems = useMemo(() => [
    { key: "accountPlan", label: "Account Plan", icon: <FeatherIcon.Grid className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key: "maximise_pipe", label: "Maximise Pipe", icon: <FeatherIcon.Briefcase className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key:"targeted_reach_out",label:"Targeted Reach Out", icon: <FeatherIcon.Target className="fa" style={{width:'16px',marginRight:'7px'}} />},
    // { key:"meeting_prep",label:"Meeting Prep", icon: <FeatherIcon.Calendar className="fa" style={{width:'16px',marginRight:'7px'}} />},
    { key: "nudges_new", label: "Nudges", icon: <FeatherIcon.Globe className="fa" style={{width:'16px',marginRight:'7px'}} /> },
    { key: "more" , label: "More", icon: <FeatherIcon.Compass className="fa" style={{width:'16px',marginRight:'7px'}} />},
  ], []);

  const handleBackToAccounts = () => {
    navigate('/clients_accounts'); // Redirects to the login page
  }

  return (
    <div className="account-details-container">

        {/* Sidebar */}
        <div className="account-details-container-sidecard-container">
        <div className="sidebar_left_container">
            {account_info_loading ? (
              <CompanyLogoSkeleton />
            ) : (
              <div className="account-logo-name-container">
                <img src="/img/back_top.png" alt="icon" className="back_btn_new_top cursorP" onClick={() => handleBackToAccounts() } />
                <img
                  src={`${COMPANY_LOGO_BASE_URL}${encodeURIComponent(account_info?.name || accountName)}`}
                  alt="Company Logo"
                  className="account-logo-name-img"
                />
                <div className="account-logo-name-txt" title={account_info?.display_name || account_info?.name || accountName}>{account_info?.display_name || account_info?.name || accountName}</div>
              </div>
            )}
        
          <Nav className="account-tabs-nav">
            {tabItems.map((tab) => (
              <Nav.Link
                className="account-tab-item"
                key={tab.key}
                active={activeParentTabKey === tab.key}
                onClick={() => handleTabChange(tab.key)}
              >
                <div className="account-tab-item-content">
                  <span className="icon_left_sub">{tab.icon}</span>  
                  {tab.label}
                </div>
                
              </Nav.Link>
            ))}
          </Nav>
        </div>
        </div>

        {/* Content Area */}
        <div className="account-details-container-content">
          {renderContent()}
        </div>
    </div>
  );
}

export default React.memo(AccountDetailsTabsV2);
